import { render, staticRenderFns } from "./TableBlueButtonLock.vue?vue&type=template&id=48d8fc45&scoped=true&"
import script from "./TableBlueButtonLock.vue?vue&type=script&lang=js&"
export * from "./TableBlueButtonLock.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueButtonLock.vue?vue&type=style&index=0&id=48d8fc45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8fc45",
  null
  
)

export default component.exports